
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/xero",
      function () {
        return require("private-next-pages/destinations/xero.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/xero"])
      });
    }
  